const state = {
    layout: [],
    nextId: 1
};

const mutations = {
    SET_LAYOUT: (state, info) => {
        state.layout = info;
        state.nextId = info.length + 1;
    },
    ADD_LAYOUT_CARD: (state, info) => {
        state.layout.push(info);
        state.nextId++;
    },
    DUPLICATE_LAYOUT_CARD: (state, info) => {
        state.layout.splice(info.duplicate_index, 0, info.duplicate_card);
        state.nextId++;
    },
    REMOVE_LAYOUT_CARD: (state, index) => {
        state.layout.splice(index, 1);
    }
};

const actions = {
    setLayout({ commit }, info) {
        commit("SET_LAYOUT", info);
    },
    addLayoutCard({ commit }, info) {
        let new_card = {
            "id": state.nextId,
            "x": (state.layout.length * 2) % 12,
            "y": 12, // puts it at the bottom
            "w": info.width ? info.width : 2,
            "h": info.height ? info.height : 2,
            "i": state.nextId,
            "type": info.cardType,
            "chartConfiguration": info.chartConfiguration
        };

        commit("ADD_LAYOUT_CARD", new_card);
    },
    duplicateLayoutCard({ commit }, info) {
        let copy_card = state.layout.find(x => x.id === info.id);
        let duplicate_card = JSON.parse(JSON.stringify(copy_card));
        duplicate_card.id = state.nextId;
        duplicate_card.x = copy_card.x + copy_card.w;

        let duplicate_index = state.layout.findIndex(x => x.id === copy_card.id);
        commit("DUPLICATE_LAYOUT_CARD", {
            duplicate_card,
            duplicate_index
        });
    },
    removeLayoutCard({ commit }, id) {
        let index = state.layout.findIndex(x => x.id === id);
        commit("REMOVE_LAYOUT_CARD", index);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/dashboard_layout.js